import React, { useEffect, useState } from 'react'
import { Pagination, Popconfirm, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDebounce } from 'use-debounce'
import CustomButton from '../../../components/CustomButton'
import { reOrgTypeActions } from './store/actions'
import Notifications from '../../../helpers/Notifications'
import CustomInput from '../../../components/CustomInput'
import LocalLoading from '../../../components/Loading/Local'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import ChangeReOrgType from './change'
import ModalAudit from '../ModalAudit'
import { useTranslation } from "react-i18next"
import dayjs from "dayjs"
import api from "./store/api"

const ReOrgTypes = ({ isModify }) => {
	const [search, setSearch] = useState(null)
	const [page, setPage] = useState(1)
	const [record, setRecord] = useState(null)
	const [visible, setVisible] = useState(false)
	const [visibleAudit, setVisibleAudit] = useState(false)
	const [idRecordAudit, setIdRecordAudit] = useState(null)
	const { paged, isSending, changed } = useSelector(state => state.reOrgTypeReducer)
	const {t} = useTranslation(['common', 'valid', 'action'])
	const pageSize = 10
	const [searchValue] = useDebounce(search, 500)
	const dispatch = useDispatch()

	const getPaged = (values) => {
		dispatch(reOrgTypeActions.getPaged(values))
	}
	const getPagedAll = (values) => {
		dispatch(reOrgTypeActions.getPagedAll(values))
	}
	const remove = (values) => {
		dispatch(reOrgTypeActions.remove(values))
	}
	const restore = (values) => {
		dispatch(reOrgTypeActions.restore(values))
	}

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		return () => {
			dispatch(reOrgTypeActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	const onPaginationChange = (page) => {
		setPage(page)
		const params = {
			name     : searchValue,
			page     : page,
			pageSize : pageSize
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	const comColumns = [
		{
			title     : t('common:code'),
			dataIndex : 'code',
			key       : 'code'
		},
		{
			title     : t('common:title'),
			dataIndex : 'name',
			key       : 'name'
		},

	]

	const manageColumns = [
		...comColumns,
		{
			title     : t('common:dateCreate'),
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => dayjs(date).format("DD.MM.YYYY")
		},
		{
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img alt=""
						src={UpdateIcon}
						title={t('edit')}
						onClick={() => {
							setVisible(true)
							setRecord(record)
						}}
					/>
					<Popconfirm
						cancelText={t('no')}
						okText={t('yes')}
						placement="left"
						title={!record.isDeleted ? t('valid:sureToDelete') : t('valid:sureToRestore')}
						onCancel={(e) => {
							e.stopPropagation()
							return null
						}}
						onConfirm={(e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						}}
					>
						<img alt=""
							src={!record.isDeleted ? DeleteIcon : RestoreIcon}
							title={!record.isDeleted ? t('action:delete') : t('action:restore')}
						/>
					</Popconfirm>
					<img alt=""
						className="audit-icon-svg"
						src={AuditIcon}
						title={t('common:historyOfChange')}
						onClick={() => {
							setVisibleAudit(true)
							setIdRecordAudit(id)
						}}
					/>
				</div>
			)
		}
	]

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={64}
					placeholder={t('action:enterNameCode')}
					onChange={(e) => setSearch(e.target.value)}
				/>
				{isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={() => {
								setRecord(null)
								setVisible(true)
							}}
						>
							<div>
								<img alt="" src={AddIcon}/>
								<span>{t('action:add')}</span>
							</div>
						</CustomButton>
					)
					: null}
			</div>
			<Table
				columns={isModify ? manageColumns : comColumns}
				dataSource={paged?.items?.map((el, idx) => ({key: el.code, ...el}))}
				loading={{indicator: <LocalLoading/>, spinning: isSending}}
				pagination={false}
				scroll={{x: 1200}}
			/>
			{paged?.count > pageSize
				? (
					<Pagination
						showQuickJumper
						current={page}
						pageSize={pageSize}
						showSizeChanger={false}
						size="small"
						total={paged?.count}
						onChange={onPaginationChange}
					/>)
				: null}
			{isModify &&
				<>
					<ChangeReOrgType
						record={record}
						setRecord={setRecord}
						setVisible={setVisible}
						visible={visible}
					/>
					<ModalAudit
						columns={comColumns}
						setIdRecordAudit={setIdRecordAudit}
						idRecordAudit={idRecordAudit}
						setVisible={setVisibleAudit}
						visible={visibleAudit}
						pageSize={pageSize}
						func={api.getPagedAudit}
					/>
				</>}
		</>
	)
}

export default ReOrgTypes